type WebSamplingContextLike = {
  name?: string;
  attributes?: Record<string, unknown>;
};

const NOISY_FRONTEND_PATH_PATTERNS = [
  /\/system\/health(?:\/|$)/i,
  /\/health(?:\/|$)/i,
];

const LOW_VALUE_HTTP_PATTERNS = [
  /\/assets\/realtime(?:\/|$)/i,
  /\/notifications(?:\/|$)/i,
  /sync/i,
  /status/i,
];

function clampRate(rate: number): number {
  if (!Number.isFinite(rate)) {
    return 0;
  }

  if (rate < 0) {
    return 0;
  }

  if (rate > 1) {
    return 1;
  }

  return rate;
}

export function resolveWebTraceSampleRate(
  baseRate: number,
  samplingContext: WebSamplingContextLike,
): number {
  const normalizedBaseRate = clampRate(baseRate);
  const transactionName = samplingContext.name ?? '';

  if (!transactionName) {
    return normalizedBaseRate;
  }

  if (NOISY_FRONTEND_PATH_PATTERNS.some((pattern) => pattern.test(transactionName))) {
    return 0;
  }

  if (/\/system\/support(?:\/|$)/i.test(transactionName)) {
    return clampRate(normalizedBaseRate * 0.2);
  }

  return normalizedBaseRate;
}

export function shouldCreateHttpClientSpan(
  url: string | undefined,
  random: () => number = Math.random,
): boolean {
  if (!url) {
    return true;
  }

  if (NOISY_FRONTEND_PATH_PATTERNS.some((pattern) => pattern.test(url))) {
    return false;
  }

  if (LOW_VALUE_HTTP_PATTERNS.some((pattern) => pattern.test(url))) {
    return random() < 0.05;
  }

  return true;
}
